export class UpdateUnitNameResponse {
    unitId: number;
    newUnitName: string;
  }